export const openZoomWidget = () => {
  const parentDiv = document.getElementById('livesdk__campaign') as HTMLElement
  const childDivs = parentDiv.getElementsByTagName('div')

  if (childDivs.length >= 4) {
    const thirdDiv = childDivs[3]
    thirdDiv.click()
  }
}
